import Icon from "@material-ui/core/Icon"
import React, { useEffect, useRef, useState } from "react"
import { NavLink, useLocation } from "react-router-dom"
import { CommonText } from "../../../common/text"
import useClickOutside from "../../../hooks/useClickOutsite"
import Button from "./Button"

//Events
export type btnEvent = React.MouseEvent<HTMLButtonElement>

export interface DropdownLink {
  label: string
  onClick?: () => void
  title?: string
  icon?: string
  route?: string
  extRoute?: string
  className?: string
}

export interface DropDownRadioGroup {
  groupTitle: string
  subtitle?: string
  radioValues: string[]
  columns: number
  onSubmit: (selectedValue: string) => void
  hidden?: boolean
}

export interface DropdownButtonProps {
  radioLinks?: DropDownRadioGroup[]
  links?: DropdownLink[]
  disabled?: boolean
  title?: string
  icon?: string
  className?: string
  hidden?: boolean
}

const DropdownButton: React.FunctionComponent<DropdownButtonProps> = ({
  children,
  disabled,
  title,
  links,
  radioLinks,
  icon,
  className
}) => {
  const checkedInitVal = radioLinks
    ? radioLinks[0].groupTitle + radioLinks[0].radioValues[0]
    : ""
  const [showDropdown, setShowDropdown] = useState(false)
  const [checked, setChecked] = useState(checkedInitVal)
  const dropdownRef = useRef()

  const handleClickOutside = () => {
    if (showDropdown) {
      setShowDropdown(false)
    }
  }

  useClickOutside({ ref: dropdownRef, onClickOutside: handleClickOutside })

  useEffect(() => {
    if (showDropdown) {
      setChecked(checkedInitVal)
    }
    // eslint-disable-next-line
  }, [showDropdown])

  const handleSubmit = () => {
    const chosenGroup = radioLinks.find((l) => checked.includes(l.groupTitle))
    const chosenVal = chosenGroup.radioValues.find(
      (v) => v === checked.replace(chosenGroup.groupTitle, "")
    )

    chosenGroup.onSubmit(chosenVal)
    setShowDropdown(false)
  }
  const { pathname } = useLocation()

  const dropddownLinks = links
    ? links.map((l, idx) => (
        <li
          key={idx}
          onClick={() => {
            l.onClick && l.onClick()
            setShowDropdown(false)
          }}
          title={l.title ?? ""}
          className={l.className}
        >
          {l.icon && <Icon className="ocs-md-btn-icon">{l.icon}</Icon>}
          {l.route ? (
            <NavLink
              to={{
                pathname: l.route,
                state: { from: { pathname: pathname } }
              }}
            >
              {l.label}
            </NavLink>
          ) : l.extRoute ? (
            <a href={l.extRoute} target="_blank" rel="noreferrer">
              {l.label}
            </a>
          ) : (
            <p>{l.label}</p>
          )}
        </li>
      ))
    : null

  const r = radioLinks
    ? radioLinks.map((l, idx) => {
        return l.radioValues.length > 0 && !l.hidden ? (
          <div
            key={idx}
            className={
              "ocs-field-container " +
              (idx !== radioLinks.length - 1 ? "ocs-mr-12" : "")
            }
          >
            <p>{l.groupTitle}</p>
            {l.subtitle && <p className="subtitle">{l.subtitle}</p>}
            <ul style={{ columnCount: l.columns }}>
              {l.radioValues.map((val, idx) => {
                const value = l.groupTitle + val
                return (
                  <li key={idx} className="radio-field ocs-mb-16">
                    <label className="ocs-radio-container d-flex align-items-center">
                      <input
                        type="radio"
                        style={{ cursor: "pointer" }}
                        onChange={() => setChecked(value)}
                        checked={checked === value}
                      />
                      <span className="ocs-radio-check" />
                      {val}
                    </label>
                  </li>
                )
              })}
            </ul>
          </div>
        ) : null
      })
    : null
  return (
    <div
      className={
        "ocs-btn-dropdown " +
        (className ? className : "") +
        (showDropdown ? " dropdown-is-open" : "")
      }
      ref={dropdownRef}
    >
      <button
        className={`ocs-btn ocs-btn-link ocs-pr-4`}
        onClick={() => setShowDropdown(!showDropdown)}
        disabled={disabled}
        title={title}
      >
        {icon && (
          <Icon className={"ocs-md-btn-icon" + (children ? " ocs-mr-4" : "")}>
            {icon}
          </Icon>
        )}
        {children && (
          <span className={!icon ? "ocs-btn-no-icon" : ""}>{children}</span>
        )}
        {!icon && (
          <Icon className="ocs-md-btn-icon">
            {showDropdown ? "expand_less" : "expand_more"}
          </Icon>
        )}
      </button>
      {showDropdown &&
        (radioLinks ? (
          <div className="radio-links-container">
            <div className="d-flex ocs-mb-12">{r}</div>
            <div className="d-flex justify-content-end radio-links-btn">
              <Button
                variant="secondary"
                onClick={() => setShowDropdown(false)}
                className="btn-margin mq-btn-height"
              >
                {CommonText.cancel}
              </Button>
              <Button
                variant="primary"
                onClick={handleSubmit}
                type="submit"
                className="mq-btn-height"
              >
                {CommonText.ok}
              </Button>
            </div>
          </div>
        ) : (
          <ul className="links-container">{dropddownLinks}</ul>
        ))}
    </div>
  )
}

export default DropdownButton
